// Compatibility resource metadata aligned to the ACTIVE EM²c economy.
// Removed resource chains are preserved in backups/pre-building-overhaul/resources.js.

import { NEW_RESOURCES } from "./productionChains";

export const RESOURCES = {
  power: { id: "power", label: "Power", unit: "kW", color: "#ffc107", icon: "Zap" },
  water: { id: "water", label: "Clean Water", unit: "L", color: "#00e5ff", icon: "Droplet" },
  oxygen: { id: "oxygen", label: "Oxygen", unit: "kg", color: "#7fffd4", icon: "Wind" },
  food: { id: "food", label: "Food", unit: "kg", color: "#a3e635", icon: "Wheat" },
  refined_metal: { id: "refined_metal", label: "Earth / General Metal Stock", unit: "t", color: "#d85c31", icon: "Layers" },
  machine_parts: { id: "machine_parts", label: "Machine Parts", unit: "u", color: "#e8a37e", icon: "Cog" },
  polymers: { id: "polymers", label: "Polymers", unit: "u", color: "#b042ff", icon: "Package" },
  credits: { id: "credits", label: "Earth Mission Funding", unit: "M$", color: "#00fa9a", icon: "Coins" },
  waste: { id: "waste", label: "Recyclable Waste", unit: "u", color: "#554433", icon: "Trash" },
  ...NEW_RESOURCES,
};

export const RESOURCE_ORDER = [
  "power", "water", "oxygen", "food", "raw_water", "metal_ore",
  "iron", "aluminum", "copper", "silicon", "construction_material",
  "machine_parts", "electronic_components", "utility_components", "structural_components",
  "hydrogen", "methane", "co2", "nitrogen", "argon", "rocket_propellant", "credits",
];

export const INITIAL_STATE = {
  power: { stored: 200, max: 200 },
  water: { stored: 200, max: 200 },
  oxygen: { stored: 200, max: 200 },
  food: { stored: 240, max: 240 },
  refined_metal: { stored: 300, max: 300 },
  machine_parts: { stored: 160, max: 160 },
  polymers: { stored: 120, max: 120 },
  credits: { stored: 200, max: 999 },
};

export const OBJECTIVES = [
  { id: "camera", label: "Move the camera (WASD, drag with right-mouse)", auto: false },
  { id: "solar_power_station", label: "Build a Solar Power Station", type: "solar_station" },
  { id: "battery_storage", label: "Build a Battery Storage Facility", type: "battery_storage" },
  { id: "water_extractor", label: "Build a Regolith Water Extractor on a Hydrated Mineral Zone", type: "water_extractor" },
  { id: "water_purifier", label: "Build a Water Purification Plant", type: "water_purifier" },
  { id: "oxygen_gen", label: "Build an Oxygen Generator", type: "oxygen_gen" },
  { id: "habitat", label: "Build a Standard Habitat Module", type: "habitat_module" },
  { id: "general_storage", label: "Build a General Storage Module", type: "small_storage" },
  { id: "relay", label: "Extend command coverage with a Relay Tower", type: "relay_tower" },
  { id: "survive", label: "Survive 5 Sols with positive life-support", sols: 5 },
];
